import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'

const Navbar = () => {
    return (
        <div className='text-3xl flex justify-between  p-10 bg-violet-400  text-slate-900 font-bold mb-8'>

            <div className='ml-5 '>
                <h1> Take a Quiz! </h1>

            </div>
            <div className='mr-5 '>
                <Link className='links' to='/'>Home</Link>

                <Link className='links' to='/blog'>Blog</Link>
                <Link className='links' to='/statistics'>Statistics</Link>

            </div>
        </div>
    );
};

export default Navbar;